import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { DatePipe } from "@angular/common";
import { TravelReimbursementModel } from "common/models/page-models/travel-reimbursement/travel-reimbursement-data.model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementFormDataService extends FormDataService<TravelReimbursementModel> {
    constructor(http: SmApiService, protected override ss: SystemService, private datePipe: DatePipe) {
        super(API_URL.addUpdateDeleteTravelReimbursementForAssignment_post, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.getTravelReimbursementDataById,
            method: API_METHODS.post
        }
        return edit;
    }

    createInstance(): TravelReimbursementModel {
        return new TravelReimbursementModel();
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            id:data.id
        };        
        return payload;
    }

    override getPostDataType() {
        return false
    }

    // override modifyModel(model, metamodel = null) {
    //     console.log(model)
    //     const startdate = (model['travelStartDate']);
    //     const enddate = (model['travelEndDate']);
    //     model['travelStartDate'] = this.datePipe.transform(startdate, 'yyyy-MM-dd HH:mm:ss');
    //     model['travelEndDate'] = this.datePipe.transform(enddate, 'yyyy-MM-dd HH:mm:ss');
    //     model['assignment_student_id'] = model.assignment_student_id;
    //     const payload = {
    //         travelStartDate:  model['travelStartDate'],
    //         travelEndDate: model['travelEndDate'],
    //         id: model['assignment_student_id'],
    //         travelDoc: model['travelDoc'],
    //         travelTitleOrRemark: model['travelTitleOrRemark']
    //     }
       

    //     return payload;
    // }

    // override modifyModel( model: any,
    //         dataModel: any) {
    //     console.log(model)
    //     console.log(dataModel);
        
    //     const startdate = (model['travelStartDate']);
    //     const enddate = (model['travelEndDate']);
      
    //     model['travelStartDate'] = this.datePipe.transform(startdate, 'yyyy-MM-dd HH:mm:ss');
    //     model['travelEndDate'] = this.datePipe.transform(enddate, 'yyyy-MM-dd HH:mm:ss');
    //     model['assignment_student_id'] = model.assignment_student_id;
        
    //     let payload: any = {
    //         travelStartDate:  model['travelStartDate'],
    //         travelEndDate: model['travelEndDate'],
    //         id: model['assignment_student_id'],
    //         travelTitleOrRemark: model['travelTitleOrRemark']
    //     };
    
       
    //     if (model.travelDoc && typeof model.travelDoc !== 'string') {
    //         payload.travelDoc = model['travelDoc'];
    //     }
    //     return payload;
    // }
    
    override modifyModel(model: any, dataModel: any) {
        // console.log('Model:', model);
        // console.log('DataModel:', dataModel);
    
        const startdate = model['travelStartDate'];
        const enddate = model['travelEndDate'];
    
        model['travelStartDate'] = this.datePipe.transform(startdate, 'yyyy-MM-dd HH:mm:ss');
        model['travelEndDate'] = this.datePipe.transform(enddate, 'yyyy-MM-dd HH:mm:ss');
        model['assignment_student_id'] = model.assignment_student_id;
    
        const formData = new FormData();
    
        formData.append('travelStartDate', model['travelStartDate']);
        formData.append('travelEndDate', model['travelEndDate']);
        formData.append('id', model['assignment_student_id']);
        formData.append('travelTitleOrRemark', model['travelTitleOrRemark'] || '');
    
        if (model.travelDoc && typeof model.travelDoc !== 'string') {
            formData.append('travelDoc', model['travelDoc']);
        }
    
        return formData;
    }
    
    
    override modifyAPIResponse(response: any) {
        return response['details'][0];
    }

    override getUpdateUrl() {
        return API_URL.addUpdateDeleteTravelReimbursementForAssignment_post;
    }

    // override  updatepostUrl(type: OperationType) {
    //     console.log('update post url');
    //     return environment.apiUrl + API_URL.editTravelReimbursement
    // }

}